// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Created by Marbes Consulting jaroslav.hudec@marbes.cz / 18.09.2018. Generated from cz.marbes.cgo.controller.OpravneniController.
 */
export default class OpravneniApi {
    /**
     * 
     *
     * @param uzivatelId 
     */
    static resetPassword(uzivatelId) {
        const uri = serverContextPath + `/api/cgo/pristupy/uzivatel/${uzivatelId}/resethesla`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param uzivatelId 
     * @param heslo 
     * @param noveHeslo 
     */
    static changePassword(uzivatelId, heslo, noveHeslo) {
        const uri = serverContextPath + `/api/cgo/pristupy/uzivatel/${uzivatelId}/zmenahesla`;
        const headers = undefined;
        const params = { heslo, noveHeslo };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param login 
     * @return java.lang.String
     */
    static getSsoHash(login) {
        const uri = serverContextPath + `/api/cgo/pristupy/ssohash`;
        const headers = undefined;
        const params = { login };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return cz.marbes.cgo.controller.vo.UzivatelInfoVO
     */
    static getUzivatel() {
        const uri = serverContextPath + `/api/cgo/pristupy/prihlasenyuzivatel`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
